import { defineAsyncComponent, h } from 'vue'

const aliases = {}

const hdf = {
  component: props => {
    const { icon, ...rest } = props
    return h(props.tag, rest, [
      h(
        defineAsyncComponent(() => import(`./hdf/hd-icon-filled-${icon}.vue`)),
        { class: 'v-icon__svg' }
      )
    ])
  }
}

export { aliases, hdf }
